import { Language } from "../../../../../types/language.type";
import { Nullable } from "../../../../../types/common";

import { FlyerTemplatePosition } from "../../../features/flyer-template/types/flyer-template-position/flyer-template-position.interface";
import { PositionCategory } from "../../../pages/flyer-detail/pages/flyer-detail-page/features/flyer-detail-page-form-position/types/flyer-detail-page-form-position-categories/flyer-detail-page-form-position-categories.interface";

import {
  IFlyerDetailPagePosition,
  IFlyerDetailPagePositionCopy,
} from "./flyer-detail-page-position.interface";
import { IFlyerDetailPagePositionMapFunction } from "./flyer-detail-page-position-map-function.type";

export const findPositionByLabel = (
  label: string,
  positions: IFlyerDetailPagePosition[]
): IFlyerDetailPagePosition | undefined => positions.find((position) => position.label === label);

export function findPositionIndexBySelectedBlock(
  positions: IFlyerDetailPagePosition[],
  selectedBlock?: Nullable<FlyerTemplatePosition>
): number {
  if (!selectedBlock || !positions.length) {
    return -1;
  }

  const position = findPositionByLabel(selectedBlock.label, positions);
  if (!position) {
    return -1;
  }

  return positions.indexOf(position);
}

export function addCategoryToSelectedBlock(
  category: PositionCategory,
  positions: IFlyerDetailPagePosition[],
  position: FlyerTemplatePosition
): IFlyerDetailPagePosition[] {
  return mapPositionAtSelectedBlock(positions, position, (position) => ({
    ...position,
    categories: (position.categories || []).concat([category.id]),
  }));
}

export function removeCategoryFromSelectedPosition(
  category: PositionCategory,
  positions: IFlyerDetailPagePosition[],
  position: FlyerTemplatePosition
): IFlyerDetailPagePosition[] {
  return mapPositionAtSelectedBlock(positions, position, (position) => ({
    ...position,
    categories: (position.categories || []).filter((c) => c !== category.id),
  }));
}

function mapPositionAtSelectedBlock(
  positions: IFlyerDetailPagePosition[],
  position: FlyerTemplatePosition,
  mapFunction: IFlyerDetailPagePositionMapFunction
): IFlyerDetailPagePosition[] {
  const positionIndex = findPositionIndexBySelectedBlock(positions, position);
  if (positionIndex < 0) {
    return positions;
  }

  return positions.map((position, index) =>
    index === positionIndex ? mapFunction(position) : position
  );
}

export function createEmptyCopy(language: Language): IFlyerDetailPagePositionCopy {
  return {
    id: 0,
    language,
    copyCard: "",
    getCopyCard: "",
    productImage: "",
    getProductImage: "",
    brandLogo: "",
  };
}

export function createPagePosition(label: string): IFlyerDetailPagePosition {
  return {
    id: 0,
    label,
    copies: [createEmptyCopy("en"), createEmptyCopy("fr")],
    products: [],
    categories: [],
    categoryDetails: [],
    merchOwners: [],
    dealStartDate: "",
    dealEndDate: "",
    badge: "",
  };
}

export function findLanguageCopyIndex(
  pagePosition: Nullable<IFlyerDetailPagePosition>,
  selectedLanguage: Language
): number {
  if (!pagePosition) {
    return -1;
  }

  const copy = pagePosition.copies.find((copyOption) => copyOption.language === selectedLanguage);
  if (copy) {
    return pagePosition!.copies.indexOf(copy);
  }
  return -1;
}
